import { render, staticRenderFns } from "./AnimalChart.vue?vue&type=template&id=62646c4d&scoped=true&"
import script from "./AnimalChart.vue?vue&type=script&lang=js&"
export * from "./AnimalChart.vue?vue&type=script&lang=js&"
import style0 from "./AnimalChart.vue?vue&type=style&index=0&id=62646c4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62646c4d",
  null
  
)

export default component.exports